/* eslint-disable complexity */
import React, { useEffect } from "react";
import styles from "./styles.css";
import infoIcon from "../../shared/images/info-grey-icon.svg";
import InputRadioButton from "../../shared/input-radio-button";
import { PropTypes } from "prop-types";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import Tooltip from "../../shared/tooltip";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { GA_EVENTS } from "./tracking";
import { WARRANTY_PROVIDER_EVENTS } from "../../../tracking/warranty-provider-events";
import getCarInfo from "../../../utils/helpers/get-car-info";
import ClassifiedCheck from "../../shared/images/classified-check.svg";
import useVehicleBasePriceLabel from "../../../hooks/use-vehicle-base-price-label";
import { API_SOURCE } from "../../../constants/app-constants";
const CdpPriceDetailCard = ({
    strikeThroughtPrice,
    carPrice,
    emiPerWeek,
    tradeInCase,
    handleEgcView,
    ewDetails,
    isExtendedWarrantySelected = false,
    handleWarrantyModalClick,
    showStrikeThru,
    updateExtendedWarrantySelectionConnect,
    handleWeeklyPaymentsTooltipClick,
    showPriceDrop = false,
    tooltipInfo,
    content,
    setSelectedEwPlanConnect = () => {}
}) => {
    const {appointmentId} = content || {};
    const { isDealerListing, isInternalListing } = getCarInfo(content) || {};
    const { emiDetails: ewEmiDetails, egc, ewText, priceMeta: { referencePrice } = {}, features = [], providerName, vasCategoryType, estimatedPrice: ewTradeInEstimatedPrice, vendorDocument = "" } = ewDetails || {};

    const { vehiclePriceLabel, isVehicleBasePriceVariant } = useVehicleBasePriceLabel({
        source: API_SOURCE.DESKTOP,
        isInternalListing,
        isDealerListing,
        tradeInCase
    });

    useEffect(() => {
        if (ewDetails) {
            setSelectedEwPlanConnect({ ...ewDetails, ewKey: ewDetails.key });
        }
    }, [ewDetails, setSelectedEwPlanConnect]);

    const updateWarrantySelection = async (type) => {
        updateExtendedWarrantySelectionConnect(type);
        await yieldToMain();
        trackDesktopCustomEventsAU(GA_EVENTS.RADIO_BUTTON_CDP, {
            ...GA_EVENTS.RADIO_BUTTON_CDP,
            eventAction: type ? "with_warranty" : "without_warranty",
            eventLabel: appointmentId
        });
    };

    const egcViewHandler = (e, val) => {
        e.stopPropagation();
        handleEgcView(val);
    };

    const handleModalClick = () => {
        if (vendorDocument) {
            window.open(vendorDocument, "_blank");
            return;
        }
        handleWarrantyModalClick();
    };

    useEffect(() => {
        if (providerName) {
            trackDesktopCustomEventsAU(WARRANTY_PROVIDER_EVENTS.detailPageImpression.eventCategory, {
                ...WARRANTY_PROVIDER_EVENTS.detailPageImpression,
                eventLabel: `${vasCategoryType}_impression`,
                providerName
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [providerName]);

    return (
        <div styleName={`styles.newPriceCardWrapper ${showPriceDrop ? "styles.removePadding" : ""}`}>
            <div styleName={`styles.outer ${!isExtendedWarrantySelected ? "styles.active" : ""}`} onClick={() => updateWarrantySelection(false)}>
                <div styleName={"styles.inputRadioWrapper"}>
                    <InputRadioButton
                        id="without-ew"
                        value={!isExtendedWarrantySelected}
                        checked={!isExtendedWarrantySelected}
                        onChange={() => updateWarrantySelection(false)}
                    />
                </div>
                <div styleName={"styles.pricingWrapper"}>
                    <div styleName={"styles.priceWrapper"}>
                        <p styleName={"styles.amount"}>
                            {carPrice}
                            {showStrikeThru && <span>{makePriceLabelRound(strikeThroughtPrice)}</span>}
                        </p>
                        <p styleName={"styles.amountPerWeek"}>
                        ${emiPerWeek}<span styleName={"styles.amountPerWeekSpan"}>/wk</span>
                            <Tooltip
                                onClickCallback={handleWeeklyPaymentsTooltipClick}
                                customStyleHeading={true}
                                heading={tooltipInfo.info.title}
                                body={tooltipInfo.info.body}
                            >
                                <img src={infoIcon} alt="Weekly Payment" />
                            </Tooltip>
                        </p>
                    </div>
                    <div styleName={`styles.egcWrapper ${isVehicleBasePriceVariant ? "styles.egcWrapperVariant" : ""}`}>
                        <p styleName={`styles.egc ${isVehicleBasePriceVariant ? "styles.egcMuted" : ""}`} onClick={isVehicleBasePriceVariant ? undefined : (e) => egcViewHandler(e, false)}>
                            {vehiclePriceLabel}
                        </p>
                        {isVehicleBasePriceVariant && (
                            <p styleName={"styles.egc styles.egcDriveAway"} onClick={(e) => egcViewHandler(e, false)}>
                                See drive away price
                            </p>
                        )}
                    </div>
                </div>

            </div>
            <div styleName={`styles.outer styles.warrantyOptionWrapper ${isExtendedWarrantySelected ? "styles.active" : ""}`} onClick={() => updateWarrantySelection(true)}>
                <div styleName={"styles.recommendedWrap"}>
                    <p styleName={"styles.recommended"}>Inclusive of Extended Warranty</p>
                </div>
                <div styleName={"styles.warrantyOptionRadioPricingWrapper"}>
                    <div styleName={"styles.inputRadioWrapper"}>
                        <InputRadioButton
                            id="ew-variant"
                            value={isExtendedWarrantySelected}
                            checked={isExtendedWarrantySelected}
                            onChange={() => updateWarrantySelection(true)}
                        />
                    </div>
                    <div styleName={"styles.pricingWrapper"}>
                        <div styleName={"styles.priceWrapper"}>
                            <p styleName={"styles.amount"}>
                                {makePriceLabelRound(tradeInCase ? ewTradeInEstimatedPrice : egc)}
                                {showStrikeThru && (
                                    <span>
                                        {makePriceLabelRound(referencePrice)}
                                    </span>
                                )}
                            </p>
                            <p styleName={"styles.amountPerWeek"}>
                          ${ewEmiDetails?.emiPerWeek}
                                <span styleName={"styles.amountPerWeekSpan"}>/wk</span>
                                <Tooltip
                                    onClickCallback={handleWeeklyPaymentsTooltipClick}
                                    customStyleHeading={true}
                                    heading={tooltipInfo?.ewInfo?.title}
                                    body={tooltipInfo?.ewInfo?.body}
                                >
                                    <img src={infoIcon} alt="Weekly Payment" />
                                </Tooltip>
                            </p>
                        </div>

                        <div styleName={`styles.egcWrapper ${isVehicleBasePriceVariant ? "styles.egcWrapperVariant" : ""}`}>
                            <p styleName={`styles.egc ${isVehicleBasePriceVariant ? "styles.egcMuted" : ""}`} onClick={isVehicleBasePriceVariant ? undefined : (e) => egcViewHandler(e, true)}>
                                {vehiclePriceLabel}
                            </p>
                            {isVehicleBasePriceVariant && (
                                <p styleName={"styles.egc styles.egcDriveAway"} onClick={(e) => egcViewHandler(e, true)}>
                                    See drive away price
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <div styleName={"styles.manufactureWrap"}>
                    <p styleName={`styles.includesMonth styles.underline`} onClick={handleModalClick}>
                        {ewText}
                    </p>
                    <ul>
                        {features.length > 0 &&
                            features.map((item, index) => (
                                <li styleName={"styles.list"} key={index} onClick={handleModalClick}>
                                    <img src={ClassifiedCheck} styleName={"styles.greenTick"}/>
                                    {item}
                                </li>
                            ))}
                    </ul>
                </div>

            </div>
        </div>
    );
};

CdpPriceDetailCard.propTypes = {
    strikeThroughtPrice: PropTypes.string,
    carPrice: PropTypes.string.isRequired,
    emiPerWeek: PropTypes.string.isRequired,
    tradeInCase: PropTypes.bool,
    handleEgcView: PropTypes.func.isRequired,
    emiDetails: PropTypes.object.isRequired,
    handleWeeklyPaymentsClick: PropTypes.func.isRequired,
    personalised: PropTypes.bool,
    ewDetails: PropTypes.object,
    isExtendedWarrantySelected: PropTypes.bool,
    updateExtendedWarrantySelectionConnect: PropTypes.func,
    handleWarrantyModalClick: PropTypes.func,
    showStrikeThru: PropTypes.bool,
    appointmentId: PropTypes.string,
    toolTipBody: PropTypes.string,
    toolTipTitle: PropTypes.string,
    handleWeeklyPaymentsTooltipClick: PropTypes.func,
    tooltipInfo: PropTypes.object,
    showPriceDrop: PropTypes.bool,
    content: PropTypes.object,
    setSelectedEwPlanConnect: PropTypes.func
};
export default CdpPriceDetailCard;
